const spanSubstring = (string, substring, global) => {
    return string.replace(new RegExp(substring, 'i'), '<span class="md-company-search-component-option__highlight">$&</span>');
}

module.exports = spanSubstring;


// WEBPACK FOOTER //
// ./js/dom-utils.js